import { AddBox, Close, Delete, Edit } from "@mui/icons-material";
import {
  Box,
  Button,
  Chip,
  Fade,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AddNewPriceTypeRow from "./AddNewPriceTypeRow";
import { API, graphqlOperation } from "aws-amplify";
import { listPriceType } from "../../../graphql";
import DeletePriceType from "./DeletePriceType";
import { showWarningSnackbar } from "../../../components/snackBar/snakbar";
import Loader from "../Components/Loader";
import { useListPriceTypesQuery } from "../../../redux/apis/pricetype.api";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  // p: 4,
  outline: "none",
   width:{xs:"80vw",md:"50vw"}
};
function CreatePriceType({
  open,
  setOpen,
  setPriceTypeArr,
  priceTypeID,
  setPriceTypeID,
  updatePriceRow,
  rowIndex,
  setUpdatedRows,
  amountRows,
}) {
  const header = [
    {
      id: "ID",
      label: "ID",
      width: 100,
      align: "left",

      required: "",
    },
    {
      id: "priceType",
      label: "Price Type",
      width: 100,
      align: "left",

      required: "",
    },
    {
      id: "action",
      label: "Action",
      width: 100,
      align: "center",
      required: "",
    },
  ];

  const [rows, setRows] = useState([
    { index: "", priceType: "", Id: "", new: true, editable: false },
  ]);
  const [loading,setLoading]=useState(false)
  const [editedRows, setEditedRows] = useState({
    index: "",
    priceType: "",
    Id: "",
    new: true,
    editable: false,
  });
  const [tempRows, setTempRows] = useState({
    index: "",
    priceType: "",
    Id: "",
    new: true,
    editable: false,
  });
  const [newPriceTypeID, setNewPriceTypeID] = useState([""]);
  const newPriceObj = {
    index: "",
    priceType: "",
    Id: "",
    new: true,
    editable: false,
  };
  const [addEvent, setAddEvent] = useState(false);
  const [deletePriceType, setDeletePriceType] = useState(false);
  const [deleteObj, setDeleteObj] = useState({});
  const handleClose = () => {
    setPriceTypeID("");
    setAddEvent(false);
    setOpen(false);
  };
    const {
      data: priceList,
      isLoading: isGroupLoading,
      isError,
    } = useListPriceTypesQuery();
  async function listPriceDetails() {
    try {
      // const res = await API.graphql(graphqlOperation(listPriceType));
      let priceTypeObj = {};
      let priceTypeArr = [];
      let priceListArr = [];
      if (priceList !== null) {
        priceList?.map((ele, ind) => {
          priceListArr.push({ label: ele.pricetype, value: ele.id });
          priceTypeObj = {
            ind: ind + 1,
            priceType: ele.pricetype,
            Id: ele.id,
            new: false,
            editable: false,
          };
          priceTypeArr.push(priceTypeObj);
        });
        setPriceTypeArr(priceListArr);
        setRows(priceTypeArr);
        setEditedRows(newPriceObj);
        setTempRows(newPriceObj);
      }
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    listPriceDetails();
  }, [priceList]);
  return (
    <Box id={open ? "CreatePriceType" : ""}>
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
      onClose={handleClose}
    >
      <Fade in={open}>
        <Paper sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Add Price Type
                <IconButton aria-label="delete" onClick={handleClose}>
                  <Close sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              padding: "15px",
            }}
          >
            <TableContainer
            sx={{
              ".MuiTableContainer-root": {
                overflowY: "scroll",
              },
              
              width: "100%",
              maxHeight:400,
              "&::-webkit-scrollbar": {
                width: "0.4em",
                height: "0.4em",
              },}}
              >
              <Table
              stickyHeader>
                <TableHead>
                  <TableRow>
                    {header.map((column) => {
                      return (
                        <TableCell
                          key={column.id}
                          minWidth={column.minWidth}
                          align={column.align}
                          sx={{
                            fontWeight: 600,
                            fontSize: "14px",
                            color: "input.label",
                            backgroundColor: "background.tablebg",
                          }}
                        >
                          {column.label}{" "}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {addEvent === true && (
                    <AddNewPriceTypeRow
                    loading={loading}
                      rows={rows}
                      setRows={setRows}
                      editedRows={editedRows}
                      setEditedRows={setEditedRows}
                      tempRows={tempRows}
                      setTempRows={setTempRows}
                      addEvent={addEvent}
                      setAddEvent={setAddEvent}
                      setPriceTypeID={setPriceTypeID}
                      priceTypeID={priceTypeID}
                      listPriceDetails={() => listPriceDetails()}
                      updatePriceRow={updatePriceRow}
                      rowIndex={rowIndex}
                      setUpdatedRows={setUpdatedRows}
                      setNewPriceTypeID={setNewPriceTypeID}
                      setLoading={setLoading}
                    />
                  )}
                  {rows.length > 0 ? (
                    <>
                      {rows.map((col, ind) => {
                        if (col.editable && priceTypeID) {
                          return (
                            <AddNewPriceTypeRow
                            loading={loading}
                              rows={rows}
                              setRows={setRows}
                              editedRows={editedRows}
                              setEditedRows={setEditedRows}
                              tempRows={tempRows}
                              setTempRows={setTempRows}
                              addEvent={addEvent}
                              setAddEvent={setAddEvent}
                              setPriceTypeID={setPriceTypeID}
                              priceTypeID={priceTypeID}
                              listPriceDetails={() => listPriceDetails()}
                              updatePriceRow={updatePriceRow}
                              rowIndex={rowIndex}
                              setUpdatedRows={setUpdatedRows}
                              ind={ind}
                              setNewPriceTypeID={setNewPriceTypeID}
                              setLoading={setLoading}
                            />
                          );
                        } else {
                          return (
                            <TableRow
                             className="noTableCellBorder"
                              sx={{
                                height: "40px",
                                ".MuiTableCell-root": {
                                  backgroundColor: "transparent !important",
                                },
                              }}
                            >
                              <TableCell>
                                {/* {col.Id} */}
                                {ind + 1}
                              </TableCell>
                              <TableCell>
                                {col.priceType}
                                {newPriceTypeID !== "" &&
                                  newPriceTypeID === col.Id && (
                                    <>
                                      <Chip
                                        key={col?.Id}
                                        size="small"
                                        sx={{
                                          marginLeft: "3px",
                                          backgroundColor: "#e63f66",
                                          color: "#ffff",
                                        }}
                                        label="New"
                                      />
                                    </>
                                  )}
                              </TableCell>
                              <TableCell align="center" >
                                <Tooltip
                                  title={"Edit"}
                                  placement="right"
                                  disableInteractive
                                  arrow
                                >
                                  <IconButton
                                    aria-label="delete"
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#D0EFFF",
                                    }}
                                    onClick={() => {
                                      setAddEvent(false);

                                      setEditedRows(col);
                                      setPriceTypeID(col.Id);

                                      let arr = [...rows];
                                      let tempArr = arr.filter((ele, index) => {
                                        if (ele.new !== true) {
                                          if (ele.Id == col.Id) {
                                            ele.editable = true;
                                            ele.new = false;
                                          } else {
                                            ele.editable = false;
                                            ele.new = false;
                                          }
                                          return ele;
                                        }
                                      });
                                      setRows(tempArr);
                                    }}
                                  >
                                    <Edit
                                      sx={{
                                        fontSize: "15px",
                                        color: "#6096d9",
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>

                                <Tooltip
                                  title={"Delete"}
                                  placement="right"
                                  disableInteractive
                                  arrow
                                >
                                  <IconButton
                                    disableRipple
                                    onClick={(event) => {
                                      let isPriceTypeMatched = amountRows.some(
                                        (row) =>
                                          row?.priceType?.value === col.Id
                                      );

                                      if (isPriceTypeMatched) {
                                        showWarningSnackbar(
                                          "Can't delete this price type because it is already used in the selling price table."
                                        );
                                      } else {
                                        setDeletePriceType(true);
                                        setPriceTypeID(col.Id);
                                        setDeleteObj(col);
                                      }
                                      //   handleDeleteClick(ele, ind);
                                    }}
                                    aria-label="delete"
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#fbc7c7",
                                    }}
                                  >
                                    <Delete
                                      sx={{
                                        fontSize: "15px",
                                        color: "#eb6a6a",
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          );
                        }
                      })}
                    </>
                  ) : (
                    <>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={3}
                          sx={{ border: "none", heigt: "40px" }}
                        >
                          No Data Found
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ dispaly: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  disableRipple
                  disableElevation
                  size="small"
                  onClick={() => {
                    let element= document?.getElementById("priceType")
                    element?.focus()
                    setAddEvent(true);
                    setPriceTypeID("");
                    setEditedRows(newPriceObj)
                    setTempRows(newPriceObj)
                   
                  }}
                  startIcon={<AddBox />}
                  sx={{
                    fontSize: "12px",
                    marginTop: "15px",
                  }}
                >
                  Add New Line
                </Button>
              </Box>
            </Box>
          </Box>
          <Loader open={loading} />
          <DeletePriceType
            open={deletePriceType}
            setOpen={setDeletePriceType}
            setPriceTypeID={setPriceTypeID}
            priceTypeID={priceTypeID}
            deleteObj={deleteObj}
            listPriceDetails={() => listPriceDetails()}
            amountRows={amountRows}
          />
        </Paper>
      </Fade>
    </Modal>
    </Box>
  );
}

export default CreatePriceType;
